import stringToCamelCase from "../string-to-camel-case/index"

export default function kebabToCamelCase(text) {
  return stringToCamelCase(text.replaceAll("-", " "))
}
